import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Paper,
} from '@mui/material';

const initialData = [
  {
    category: 'İŞLETME GİDERLERİ',
    rows: [
      { name: 'Yönetici Ücretleri', year1: 1111, year2: 0, year3: 0, year4: 0, year5: 0 },
      { name: 'Personel Ücretleri', year1: 1000, year2: 0, year3: 0, year4: 0, year5: 0 },
    ],
  },
  {
    category: 'İLETİŞİM/HABERLEŞME GİDERLERİ',
    rows: [
      { name: 'Telefon', year1: 123123, year2: 0, year3: 0, year4: 0, year5: 0 },
    ],
  },
];

function DynamicTable() {
  const [data, setData] = useState(initialData);

  const handleInputChange = (categoryIndex, rowIndex, field, value) => {
    const newData = [...data];
    newData[categoryIndex].rows[rowIndex][field] = parseFloat(value) || 0; // Güncellenen değeri sayıya çevir
    setData(newData);
  };

  const calculateCategoryTotal = (category) => {
    return category.rows.reduce((acc, row) => ({
      year1: acc.year1 + row.year1,
      year2: acc.year2 + row.year2,
      year3: acc.year3 + row.year3,
      year4: acc.year4 + row.year4,
      year5: acc.year5 + row.year5,
    }), { year1: 0, year2: 0, year3: 0, year4: 0, year5: 0 });
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Kategori</TableCell>
            <TableCell>1.YIL</TableCell>
            <TableCell>2.YIL</TableCell>
            <TableCell>3.YIL</TableCell>
            <TableCell>4.YIL</TableCell>
            <TableCell>5.YIL</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((category, categoryIndex) => (
            <React.Fragment key={categoryIndex}>
              <TableRow>
                <TableCell colSpan={6} sx={{ fontWeight: 'bold' }}>
                  {category.category}
                </TableCell>
              </TableRow>
              {category.rows.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  <TableCell>{row.name}</TableCell>
                  {['year1', 'year2', 'year3', 'year4', 'year5'].map((field, index) => (
                    <TableCell key={index}>
                      <TextField
                        type="number"
                        value={row[field]}
                        size="small"
                        onChange={(e) =>
                          handleInputChange(categoryIndex, rowIndex, field, e.target.value)
                        }
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>Toplam</TableCell>
                {Object.values(calculateCategoryTotal(category)).map((total, index) => (
                  <TableCell key={index} sx={{ fontWeight: 'bold' }}>{total}</TableCell>
                ))}
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default DynamicTable;
